export default __webpack_public_path__ + "static/media/clinica-odontologica.0e9bed50.png";